import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGenderFemale: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gender-female"><circle cx="12" cy="8.5" r="5.75" stroke="currentColor" strokeWidth="1.5"/><path d="M12 14.5V21.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M8.75 18.25H15.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGenderFemale;
